import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
    `<div>
  <h4>Description - Spill</h4>
  <p>
      The associate has reported a spill or a leaking package and needs immediate assistance in clearing the area. This will protect associate from the spill and minimize any delay it might have caused.
  </p>
  <h4>Resolution Steps</h4>
  <p>
      1. Notify RME facilities of the spill. Inform them Lock out/Tag out must be completed for cleaning. <br />
      2. Reach out to the associate at the indicated location to ensure their safety. <br />
      3. Follow the <span className="wikiinternallink"><a href="https://start.wwops.amazon.dev/boards/browse?boardId=IjIxMzM4Ig%3D%3D&businessUnitId=IjM[…]Y3Il0%3D&topLevelFilters=eyI0IjoiNDEiLCI2IjoiNTgifQ%3D%3D">SOP</a></span> to contain and clean the spill. <br />
      4. Once you resolve the request mark task as completed.
  </p>
</div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Spill.jsx